import {
  findCourseDescriptorFromParents,
  findPageDescriptorByPath,
  pm2SitemapStore,
} from "@pm2/sitemap-utils";
import { pm2ConfigStore } from "@pm2/store";

import { Helmet } from "../../server/utils/module.react-helmet-async";
import { joinDocumentTitle } from "../utils";

type Props = {
  path: string;
};

export const Head: React.FC<Props> = ({ path }) => {
  const sitemap = pm2SitemapStore.useSelector((state) => state);
  const pageDescriptor = findPageDescriptorByPath(sitemap, path);

  const portalTitle = pm2ConfigStore.useSelector((state) => state.config.title);
  const portalHost = pm2ConfigStore.useSelector((state) => state.host);
  const portalPublisher = pm2ConfigStore.useSelector(
    (state) => state.config.publisher ?? "gyldendal",
  );
  const fallbackDescription = pm2ConfigStore.useSelector(
    (state) => state.fallbackMetaDescription[path],
  );
  const defaultPreviewImage = pm2ConfigStore.useSelector(
    (state) => state.config.theme.productLogoImage,
  );

  const title = joinDocumentTitle(pageDescriptor?.title, portalTitle);
  const description = pageDescriptor?.description || fallbackDescription;

  const courseDescriptor = findCourseDescriptorFromParents(
    sitemap,
    pageDescriptor,
  );

  const previewImage =
    pageDescriptor?.vignette?.url ||
    courseDescriptor?.vignette?.url ||
    defaultPreviewImage ||
    `https://${portalHost}/assets/social/${portalPublisher}.png`;

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}

      {/* Social Media Card */}
      <meta itemProp="image" content={previewImage} />
      <meta property="og:image" content={previewImage} />
      <meta name="twitter:image" content={previewImage} />

      {/* Search Engine */}
      <meta itemProp="name" content={title} />
      {description && <meta itemProp="description" content={description} />}

      {/* Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
    </Helmet>
  );
};
